import React, { useContext, useMemo, useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { perguntarIa } from '../services/iaService';
import { AuthContext } from '../contexts/AuthContext';
import liaAvatar from '../assets/lia.png.png';
import { useModules } from '../contexts/ModuleContext';

const AssistenteIa = () => {
  const { token } = useContext(AuthContext);
  const location = useLocation();
  const { hasModule } = useModules();

  const [aberto, setAberto] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [pergunta, setPergunta] = useState('');
  const [mensagens, setMensagens] = useState([
    {
      tipo: 'ia',
      texto: 'Olá! Sou a Lia do CultivaMais. Posso ajudar com dúvidas sobre o sistema.'
    }
  ]);

  const chatRef = useRef(null);

  const isDark =
    document.body.classList.contains('dark-mode') ||
    document.documentElement.classList.contains('dark-mode');

  const deveOcultar = useMemo(() => {
    const rotasOcultas = ['/login', '/forgot-password', '/reset-password'];
    return !token || !hasModule('lia') || rotasOcultas.includes(location.pathname);
  }, [token, location.pathname, hasModule]);

 useEffect(() => {
  const el = chatRef.current;

  if (!el) return;

  el.scrollTop = el.scrollHeight;
}, [mensagens, carregando]);

  const enviarPergunta = async (operacaoPendente = null) => {
    const texto = operacaoPendente || pergunta.trim();

    if (!texto || carregando) {
      return;
    }

    if (!operacaoPendente) {
      setMensagens((prev) => [...prev, { tipo: 'usuario', texto }]);
      setPergunta('');
    }
    setCarregando(true);

    try {
      const data = await perguntarIa(texto, Boolean(operacaoPendente));

      setMensagens((prev) => [
        ...prev,
        {
          tipo: 'ia',
          texto: data?.resposta || 'Não consegui responder agora.',
          operacaoPendente: data?.requerConfirmacao ? data.operacaoPendente : null
        }
      ]);
    } catch (error) {
      setMensagens((prev) => [
        ...prev,
        {
          tipo: 'ia',
          texto: 'Ocorreu um erro ao consultar a assistente.'
        }
      ]);
    } finally {
      setCarregando(false);
    }
  };

  if (deveOcultar) {
    return null;
  }

  return (
    <>
      {aberto && (
        <div
          className="shadow rounded"
          style={{
            position: 'fixed',
            right: '20px',
            bottom: '85px',
            width: '380px',
            maxWidth: 'calc(100vw - 30px)',
            zIndex: 9999,
            background: isDark ? '#1b1d2a' : '#ffffff',
            border: isDark ? '1px solid #3b3f5c' : '1px solid #dfe3e8',
            overflow: 'hidden'
          }}
        >
          <div
            className="px-3 py-2 d-flex justify-content-between align-items-center"
            style={{
              background: 'linear-gradient(90deg, #28a745 0%, #34c759 100%)',
              color: '#fff'
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <img
                src={liaAvatar}
                alt="Lia do Cultiva"
                style={{
                  width: '38px',
                  height: '38px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: '2px solid rgba(255,255,255,0.7)',
                  background: '#fff'
                }}
              />
              <div>
                <div style={{ fontWeight: 700, lineHeight: 1.1 }}>
                  Lia do Cultiva
                </div>
                <small style={{ opacity: 0.95 }}>
                  Assistente virtual
                </small>
              </div>
            </div>

            <button
              className={`btn btn-sm ${isDark ? 'btn-outline-light' : 'btn-light'}`}
              onClick={() => setAberto(false)}
              type="button"
            >
              ×
            </button>
          </div>

          <div
            ref={chatRef}
            style={{
              height: '380px',
              overflowY: 'auto',
              padding: '12px',
              background: isDark ? '#151722' : '#f8f9fa'
            }}
          >
            {mensagens.map((msg, index) => {
              const isUsuario = msg.tipo === 'usuario';

              return (
                <div
                  key={index}
                  className={`mb-3 d-flex ${isUsuario ? 'justify-content-end' : 'justify-content-start'}`}
                >
                  {!isUsuario && (
                    <img
                      src={liaAvatar}
                      alt="Lia"
                      style={{
                        width: '34px',
                        height: '34px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        marginRight: '8px',
                        marginTop: '2px',
                        flexShrink: 0,
                        border: isDark ? '1px solid #444a6d' : '1px solid #dfe3e8',
                        background: '#fff'
                      }}
                    />
                  )}

                  <div
                    className="px-3 py-2 rounded"
                    style={{
                      maxWidth: '78%',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                      background: isUsuario
                        ? '#28a745'
                        : isDark
                          ? '#2a2d44'
                          : '#ffffff',
                      color: isUsuario
                        ? '#ffffff'
                        : isDark
                          ? '#f1f3f5'
                          : '#212529',
                      border: isUsuario
                        ? 'none'
                        : isDark
                          ? '1px solid #444a6d'
                          : '1px solid #dee2e6',
                      boxShadow: isDark
                        ? '0 2px 6px rgba(0,0,0,0.35)'
                        : '0 2px 6px rgba(0,0,0,0.08)',
                      borderTopLeftRadius: isUsuario ? '16px' : '6px',
                      borderTopRightRadius: isUsuario ? '6px' : '16px',
                      borderBottomLeftRadius: '16px',
                      borderBottomRightRadius: '16px'
                    }}
                  >
                    {msg.texto}
                    {msg.operacaoPendente && <div className="d-flex gap-2 mt-3 pt-2 border-top"><button type="button" className="btn btn-success btn-sm" disabled={carregando} onClick={() => { setMensagens((prev) => prev.map((item, i) => i === index ? { ...item, operacaoPendente: null } : item)); enviarPergunta(msg.operacaoPendente); }}><i className="bi bi-check-circle me-1" />Confirmar operação</button><button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setMensagens((prev) => prev.map((item, i) => i === index ? { ...item, operacaoPendente: null, texto: `${item.texto}\n\nOperação cancelada.` } : item))}>Cancelar</button></div>}
                  </div>
                </div>
              );
            })}

            {carregando && (
              <div className="d-flex align-items-center">
                <img
                  src={liaAvatar}
                  alt="Lia"
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    marginRight: '8px',
                    border: isDark ? '1px solid #444a6d' : '1px solid #dfe3e8',
                    background: '#fff'
                  }}
                />
                <div
                  className="px-3 py-2 rounded"
                  style={{
                    background: isDark ? '#2a2d44' : '#ffffff',
                    color: isDark ? '#cfd3da' : '#6c757d',
                    border: isDark ? '1px solid #444a6d' : '1px solid #dee2e6'
                  }}
                >
                  Pensando...
                </div>
              </div>
            )}
          </div>

          <div
            className="p-2"
            style={{
              borderTop: isDark ? '1px solid #3b3f5c' : '1px solid #dee2e6',
              background: isDark ? '#1b1d2a' : '#ffffff'
            }}
          >
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Digite sua dúvida..."
                value={pergunta}
                onChange={(e) => setPergunta(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    enviarPergunta();
                  }
                }}
                style={{
                  background: isDark ? '#2a2d44' : '#ffffff',
                  color: isDark ? '#f1f3f5' : '#212529',
                  border: isDark ? '1px solid #444a6d' : '1px solid #ced4da'
                }}
              />
              <button
                className="btn btn-success"
                onClick={() => enviarPergunta()}
                disabled={carregando}
                type="button"
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      )}

      <button
        className="btn btn-success rounded-circle shadow"
        onClick={() => setAberto((prev) => !prev)}
        style={{
          position: 'fixed',
          right: '20px',
          bottom: '20px',
          width: '60px',
          height: '60px',
          zIndex: 9999,
          padding: 0,
          overflow: 'hidden',
          border: '2px solid rgba(255,255,255,0.4)'
        }}
        title="Abrir assistente"
        type="button"
      >
        <img
          src={liaAvatar}
          alt="Lia"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      </button>
    </>
  );
};

export default AssistenteIa;
